module.exports = __webpack_public_path__ + "images/services/jira-mark-gradient-blue.4641c6efb160111315b7.svg";